<script setup>
import { computed, watch, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import {
  setSocialMetaTag,
  updateSocialMetaTag,
  getFullPathAsset,
} from '@/utils/setMetaTags';
import EventSelector from './EventSelector.vue';

const route = useRoute();
document.title = route.meta.title;

const props = defineProps({
  id: String,
});

const store = useStore();

const event = computed(() => store.getters['events/event'](props.id));

const solutions = computed(() => store.state.solutions.solutions);

const isLoading = computed(() => store.state.events.loaded === false);

/**
 * Meta tags control
 */
onMounted(() => {
  setSocialMetaTag('og:title', event.value?.name ?? '');
  setSocialMetaTag('og:description', event.value?.description ?? '');
  setSocialMetaTag('og:image', getFullPathAsset(event.value?.assetForWaitingRoom?.fileName ?? ''));
});
watch(event, () => {
  updateSocialMetaTag('og:title', event.value.name);
  updateSocialMetaTag('og:description', event.value.description);
  updateSocialMetaTag('og:image', getFullPathAsset(event.value.assetForWaitingRoom?.fileName));
});
</script>

<template>
  <event-selector
    :event="event"
    :solutions="solutions"
    :is-loading="isLoading" />
</template>
